import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unsigned',
  templateUrl: './unsigned.component.html',
  styleUrls: ['./unsigned.component.scss']
})
export class UnsignedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
